/**
 * 작업지시서 행(row) 하나가 "난수 미입력" 상태인지 판정하는 단일 진입점.
 *
 * SPEC-CHINA-GLOBAL-RANDOMNO-BANNER-001
 *
 * 판정 기준: prosthetic.toothDetails[] 중 하나라도 randomNo가 비어 있으면 미입력으로 간주한다.
 * 카드 1장(toothDetails 엔트리)이 여러 치아를 커버할 수 있어 치아 개수와 난수 개수가 다른 것은
 * 정상이므로, 치아 개수 vs 난수 개수 비교는 절대 하지 않는다 — toothDetails 엔트리별 randomNo
 * 유무만 본다.
 *
 * ManualWorkOrders.vue의 missingRandomNoRows computed와 store/modules/missingRandomNo.js가
 * 이 함수를 공유해 두 로직이 어긋나지 않도록 한다.
 *
 * @param {Object} row - 작업지시서 목록 응답의 행 하나 (getWorkOrders 응답 data[] 원소)
 * @returns {boolean}
 */
export function hasMissingRandomNo(row) {
  const details = row?.prosthetic?.toothDetails || [];
  return details.some((d) => !d.randomNo || !String(d.randomNo).trim());
}
